import { render, staticRenderFns } from "./firstYear.vue?vue&type=template&id=96937fc6&scoped=true"
import script from "./firstYear.vue?vue&type=script&lang=js"
export * from "./firstYear.vue?vue&type=script&lang=js"
import style0 from "./firstYear.vue?vue&type=style&index=0&id=96937fc6&prod&lang=scss&scoped=true"
import style1 from "./firstYear.vue?vue&type=style&index=1&id=96937fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96937fc6",
  null
  
)

export default component.exports